import { Controller } from "stimulus";

let eventValue = ""

export default class extends Controller {

  static targets = [];
  static values = {};

  connect() {
  }

  open() {
    document.body.classList.add("modal-open");
    this.element.setAttribute("style", "display: block;");
    this.element.classList.add("show");
    document.body.innerHTML += '<div class="modal-backdrop fade show"></div>';
  }

  close(e) {
    this._prevents(e)
    document.body.classList.remove("modal-open");
    this.element.removeAttribute("style");
    this.element.classList.remove("show");
    document.getElementsByClassName("modal-backdrop")[0].remove();
    eventValue = ""
  }

  setCoHostContent(e) {
    eventValue = e
  }

  confirm(e) {
    this._prevents(e)
    if (eventValue) this.dispatch("triggerModalConfirmed", { detail: eventValue })
    this.close(e)
  }

  _prevents(e) {
    e.preventDefault();
    e.stopPropagation();
  }

}
